<!-- Translated: yes -->
<template>
  <div class="embed-container">
  </div>
</template>

<script>
export default {
  props: ['url'],
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$nextTick(() => {
      const ifrm = document.createElement('iframe');
      ifrm.setAttribute('src', this.url);
      ifrm.setAttribute('border', '0');
      ifrm.setAttribute('frameborder', '0');
      this.$el.appendChild(ifrm);
      // this.$el.innerHTML = `<iframe :src='${this.url}'
      // frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>`;
    });
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// Vimeo.vue?36c56280